import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {
    name: "",
  },
  isLoaded: false,
};

const userRoleSlice = createSlice({
  name: "userRole",
  initialState,
  reducers: {
    setUserRoles: (state, { payload }) => {
      state.list = payload;
    },
    addUserRolesToList: (state, { payload }) => {
      var createdDoctor = {
        id: payload.id,
        name: payload.name,
      };
      state.list.push(createdDoctor);
    },
    removeUserRolesToList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    updateUserRolesList: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    clearUserRoles: (state) => {
      state.list = [];
    },
    setSelectedUserRoles: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedUserRoles: (state) => {
      state.selected = {
        name: "",
      };
    },
  },
});

export const {
  setUserRoles,
  setSelectedUserRoles,
  clearSelectedUserRoles,
  clearUserRoles,
  updateUserRolesList,
  removeUserRolesToList,
  addUserRolesToList,
} = userRoleSlice.actions;
export default userRoleSlice.reducer;
